import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EditorType } from '../../../../samwebDescription/samweb/editorType';
import { Observable } from 'rxjs';
import { ConfigurableEditorSettingRemoteDto } from '../../../../../generated/swagger';
import _ from 'lodash';

@Component({
   selector: 'samweb-configurable-editor-setting-part',
   templateUrl: './configurable-editor-setting-part.component.html',
   styleUrls: ['./configurable-editor-setting-part.component.scss'],
})
export class ConfigurableEditorSettingPartComponent implements OnInit {
   public possibleEditorTypes = EditorType.values();

   @Input()
   public selectedEditorType$: Observable<EditorType>;

   @Input()
   public configurableEditorSettings$: Observable<ConfigurableEditorSettingRemoteDto>;

   @Output()
   public editorTypeSelected = new EventEmitter<EditorType>();

   @Output()
   public editorSettingsChanged = new EventEmitter<ConfigurableEditorSettingRemoteDto>();

   constructor() {}

   ngOnInit() {}

   changeEditorType(editorType: EditorType) {
      this.editorTypeSelected.emit(editorType);
   }

   showDecimalsChanged(isChecked: boolean, editorSettings: ConfigurableEditorSettingRemoteDto) {
      const settings = _.cloneDeep(editorSettings);
      settings.showDecimals = isChecked;
      this.editorSettingsChanged.emit(settings);
   }

   showThousandSeparatorChanged(isChecked: boolean, editorSettings: ConfigurableEditorSettingRemoteDto) {
      const settings = _.cloneDeep(editorSettings);
      settings.showThousandSeparator = isChecked;
      this.editorSettingsChanged.emit(settings);
   }

   checkboxValueChanged(value: string, editorSettings: ConfigurableEditorSettingRemoteDto) {
      const settings = _.cloneDeep(editorSettings);
      settings.checkboxValue = value;
      this.editorSettingsChanged.emit(settings);
   }

   isPlaintextModeChanged(isPlaintextMode: boolean, editorSettings: ConfigurableEditorSettingRemoteDto) {
      const settings = _.cloneDeep(editorSettings);
      settings.isPlaintextMode = isPlaintextMode;
      this.editorSettingsChanged.emit(settings);
   }

   selectorValuesChanged(values: any, editorSettings: ConfigurableEditorSettingRemoteDto) {
      const settings = _.cloneDeep(editorSettings);
      settings.selectorValues = values;
      this.editorSettingsChanged.emit(settings);
   }
}
